import { render, staticRenderFns } from "./plan-administration-infirmier.vue?vue&type=template&id=ef36bb54&scoped=true"
import script from "./plan-administration-infirmier.vue?vue&type=script&lang=js"
export * from "./plan-administration-infirmier.vue?vue&type=script&lang=js"
import style0 from "./plan-administration-infirmier.vue?vue&type=style&index=0&id=ef36bb54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef36bb54",
  null
  
)

export default component.exports